let showHideAppStore = (appStoreId) => {
  [...document.getElementsByClassName(appStoreId)].forEach((element) => {
    element.classList.remove("d-none");
    element.classList.remove("d-block");
  });
};

let checkOS = () => {
  let userAgent = window.navigator.userAgent;
  // OS List : 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K','Win32', 'Win64', 'Windows', 'WinCE','iPhone', 'iPad', 'iPod'
  const iosPlatforms = ["iPhone", "iPad", "iPod"];
  let ios = iosPlatforms.some((w) => window.navigator.userAgent.includes(w));
  try {
    if (/Android/.test(userAgent) || ios) {
      if (ios) {
        showHideAppStore("appStore_0");
      } else {
        showHideAppStore("appStore_1");
      }
    }
  } catch (e) {
    console.log(e);
  }
};

checkOS(); 
